import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  fetchPurchase,
  fetchSupplierMaster,
  fetchDetailMaster,
  fetchItemMaster,
} from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import { withRouter } from "../HOC/withRouter";
import PurchaseItemEntry from "./PurchaseItemEntry";
import DetailMaster from "./DetailMaster";
import SupplierMaster from "./SupplierMaster";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  validatedate_min_max,
  copyRowsAllCols,
  isNumeric,
  getTaxNumFromStr,
  getRowColSum,
  getRowColData,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import PaymentModeTable from "./PaymentModeTable";
import MoreInfoTextEditor from "./MoreInfoTextEditor";

class PurchaseEntry extends Component {
  state = {
    SupplierList: [],
    ItemNameList: [],
    StoreList: [],
    PackingList: [],
    TaxNameList: [],
    BillNoList: [],
    DefaultEntrySettingList: [],
    StoreList: [],
    PurchaseInvoiceGeneration: [],
    LedgerNameList: [],
    DetailList: [],
    DetailListCols: ["bint_displayorderno", "vac_headingvalue"],
    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],
    TransactionType: [{ name: "Paid" }, { name: "Remain" }],
    SupplierStateCode: "",
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_itemsrno", label: "Sr. No." },
      { id: "vac_storename", label: "Store Name" },
      { id: "vac_itemname", label: "Item Name" },
      // { id: "vac_hsncode", label: "HSN" },
      { id: "vac_unit", label: "Packing" },
      { id: "dec_qty", label: "Qty" },
      { id: "dec_rate", label: "Rate" },
      { id: "dec_basicamt", label: "Basic Amt" },
      { id: "dec_cashdisper", label: "Dis (%)" },
      { id: "dec_cashdisamt", label: "Dis Amt" },
      { id: "dec_taxableamount", label: "Taxable" },
      { id: "vac_taxname", label: "Tax" },
      { id: "dec_cgstamt", label: "CGST" },
      { id: "dec_sgstamt", label: "SGST" },
      { id: "dec_igstamt", label: "IGST" },
      { id: "dec_totalamount", label: "Total Amount" },
      { id: "vac_remark", label: "Remark" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "PurchaseEntry:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "PurchaseEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Purchase == "R" ||
          this.props.userPrivilege.Purchase == "W",
      },
    ],

    formData: {
      edit_purchasesrno: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      cmbSupplier: "",
      txtBillNo: "",
      txtDiscountAmount: "",
      txtTaxable: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtGrandTotal: "",
      txtAdvPayment: "",
      txtRoundOff: "",
      txtNetPayment: "",
      cmbTransactionType: "",
      txtRemark: "",
      tblCGST: 0,
      tblSGST: 0,
      tblIGST: 0,
    },

    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    totalBeforeTaxAmt: 0,
    totalAfterTaxAmt: 0,

    columnsOtherDetail: [
      { id: "Action", label: "" },
      { id: "vac_headingvalue", label: "Headings" },
      { id: "txtFormate", label: "" },
      {
        id: "vac_value",
        label: "Values",
        type: "CtTxt",
        CtrlProps: {
          value: "",
          width: 150,
          maxLength: 20,
          amountOnlyCondition: [
            {
              colID: "vac_calculation",
              value: "-",
              relationalOperator: "===",
              logicalOperator: "||",
            },
            {
              colID: "vac_calculation",
              value: "+",
              relationalOperator: "===",
              logicalOperator: "||",
            },
          ],
        },
      },
    ],
    rowsOtherDetail: [],
    rowsOtherDetail1: [],

    rowsCountOtherDetail: 0,
    rowsCountOtherDetail1: 0,

    rowsPerPageOtherDetail: 5,
    rowsPerPageOtherDetail1: 5,

    // columnsPaymentMode: [
    //   { id: "vac_ledgername", label: "Payment Mode Ledger" },
    //   {
    //     id: "dec_amount",
    //     label: "Amount",
    //     type: "CtTxtAmt",
    //     CtrlProps: { value: "", width: 100, maxLength: 20 },
    //   },
    //   {
    //     id: "vac_chequeno",
    //     label: "Cheque No",
    //     type: "CtTxtNum",
    //     CtrlProps: { value: "", width: 100, maxLength: 20 },
    //   },
    //   {
    //     id: "vac_referenceno",
    //     label: "Reference No",
    //     type: "CtTxtNum",
    //     CtrlProps: { value: "", width: 100, maxLength: 20 },
    //   },
    //   {
    //     id: "dat_transactiondate",
    //     label: "Transaction Date",
    //     type: "CtDtp",
    //     CtrlProps: { value: "", maxLength: 20 },
    //   },
    //   {
    //     id: "vac_remark",
    //     label: "Remark",
    //     type: "CtMultiLineText",
    //     CtrlProps: { value: "", width: 120, maxLength: 100 },
    //   },
    //   { id: "vac_groupname", label: "Group Name", hide: true },
    // ],
    rowsPaymentMode: [],
    rowsCountPaymentMode: 0,
    rowsPerPagePaymentMode: 5,
    PaymentData: [],
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Purchase Entry";
    this.props.setActiveMenu("PurchaseEntry");
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbSupplier") {
          this.getStateCodeOFPurchase();
        } else if (e.target.name === "txtAdvPayment") {
          this.calNetAmount();
        }
        if (e.target.name === "cmbTransactionType") {
          if (this.state.formData.cmbTransactionType === "Paid") {
            this.setState(
              {
                formData: {
                  ...this.state.formData,
                  txtAdvPayment: 0,
                },
              },
              () => {
                this.calNetAmount();
              }
            );
          }
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {
    let bint_itemsrno = row.bint_itemsrno,
      vac_itemname = row.vac_itemname,
      actionName = row.actionName,
      edit_purchasesrno = this.state.formData.edit_purchasesrno,
      bint_acyear = localStorage.getItem("ACY"),
      bint_acid = localStorage.getItem("acid"),
      EditPurchaseItemData = [],
      SupplierStateCode = "";
    if (actionName === "Edit") {
      let ARD = null;
      EditPurchaseItemData = [
        {
          bint_itemsrno: row.bint_itemsrno,
          vac_storename: row.vac_storename,
          vac_itemname: row.vac_itemname,
          vac_unit: row.vac_unit,
          dec_qty: row.dec_qty,
          dec_rate: row.dec_rate,
          dec_basicamt: row.dec_basicamt,
          dec_disper: row.dec_disper,
          dec_disamt: row.dec_disamt,
          dec_taxable: row.dec_taxable,
          vac_taxname: row.vac_taxname,
          dec_cgstamt: row.dec_cgstamt,
          dec_sgstamt: row.dec_sgstamt,
          dec_igstamt: row.dec_igstamt,
          dec_totalamt: row.dec_totalamt,
          vac_remark: row.vac_remark,
        },
      ];
      this.removeKeyboardShortCuts();
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage={
              <PurchaseItemEntry
                bint_itemsrno={bint_itemsrno}
                edit_purchasesrno={edit_purchasesrno}
                getItemList={this.getItemList}
                refreshPurchaseItemList={this.refreshPurchaseItemList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                EditPurchaseItemData={EditPurchaseItemData}
                dtpDate={this.state.formData.dtpDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                txtBillNo={this.state.formData.txtBillNo}
                cmbSupplier={this.state.formData.cmbSupplier}
                SupplierStateCode={this.state.SupplierStateCode}
                txtDiscount={this.state.formData.txtDiscountAmount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={
                  this.getPaymentModeDataStatus()
                    ? this.state.rowsPaymentMode
                    : []
                }
                rowsOtherDetail={this.state.rowsOtherDetail}
                rowsOtherDetail1={this.state.rowsOtherDetail1}
                totalBeforeTaxAmt={this.state.totalBeforeTaxAmt}
                totalAfterTaxAmt={this.state.totalAfterTaxAmt}
              />
            }
            defaultOpenDialog={true}
            handleOnClickNo={this.ShortCut}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD }, () => {
          // console.log("this.state.ARD", this.state.ARD);
        });
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Item : " + vac_itemname + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.deletePurchaseItem(
                bint_acyear,
                bint_acid,
                edit_purchasesrno,
                bint_itemsrno
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    }
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_storename.length === 0 ||
            (row["vac_storename"] &&
              row["vac_storename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_storename.toLowerCase()
                ))) &&
          (this.state.searchData.vac_itemname.length === 0 ||
            (row["vac_itemname"] &&
              row["vac_itemname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_itemname.toLowerCase()))) &&
          (this.state.searchData.vac_unit.length === 0 ||
            (row["vac_unit"] &&
              row["vac_unit"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_unit.toLowerCase()))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase()))) &&
          (this.state.searchData.vac_taxname.length === 0 ||
            (row["vac_taxname"] &&
              row["vac_taxname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_taxname.toLowerCase()))) &&
          (this.state.searchData.dec_qty.length === 0 ||
            (row["dec_qty"] &&
              Number(row["dec_qty"]) ==
                Number(this.state.searchData.dec_qty))) &&
          (this.state.searchData.dec_rate.length === 0 ||
            (row["dec_rate"] &&
              Number(row["dec_rate"]) ==
                Number(this.state.searchData.dec_rate)))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnNewEntryClick = () => {
    if (this.validatePurchase() === true) {
      let ARD = null;
      this.setState({ ARD }, () => {
        this.removeKeyboardShortCuts();
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage={
              <PurchaseItemEntry
                refreshPurchaseItemList={this.refreshPurchaseItemList}
                getItemList={this.getItemList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                edit_purchasesrno={this.state.formData.edit_purchasesrno}
                dtpDate={this.state.formData.dtpDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                txtBillNo={this.state.formData.txtBillNo}
                // bint_billno={this.state.formData.txtBillNo}
                cmbSupplier={this.state.formData.cmbSupplier}
                SupplierStateCode={this.state.SupplierStateCode}
                // cmbShipTo={this.state.formData.cmbShipTo}
                // txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscountAmount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={
                  this.getPaymentModeDataStatus()
                    ? this.state.rowsPaymentMode
                    : []
                }
                rowsOtherDetail={this.state.rowsOtherDetail}
                rowsOtherDetail1={this.state.rowsOtherDetail1}
                totalBeforeTaxAmt={this.state.totalBeforeTaxAmt}
                totalAfterTaxAmt={this.state.totalAfterTaxAmt}
              />
            }
            defaultOpenDialog={true}
            handleOnClickNo={() => {
              this.ShortCut();
            }}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };
  handleChangeRowsPerPageOtherDetail1 = (rowsPerPageOtherDetail1) => {
    this.setState({ rowsPerPageOtherDetail1 });
  };

  handleOnNewEntryClickOtherDetail = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<DetailMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={this.getDetailList}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPagePaymentMode = (rowsPerPagePaymentMode) => {
    this.setState({ rowsPerPagePaymentMode });
  };

  handleOnRowDataChangeOtherDetail = (
    rowsOtherDetail,
    handledRowIndex,
    colID
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: 0,
          tblSGST: 0,
          tblIGST: 0,
        },
      },
      () => {
        let totalBeforeTaxAmt = 0;
        let totalAfterTaxAmt = 0;
        let tblCGST = 0,
          tblSGST = 0,
          minustblIGST = 0,
          plustblIGST = 0;

        if (isNumeric(this.state.formData.tblCGST)) {
          tblCGST = Number(this.state.formData.tblCGST);
        }
        if (isNumeric(this.state.formData.tblSGST)) {
          tblSGST = Number(this.state.formData.tblSGST);
        }
        if (isNumeric(this.state.formData.tblIGST)) {
          minustblIGST = Number(this.state.formData.tblIGST);
          plustblIGST = Number(this.state.formData.tblIGST);
        }
        rowsOtherDetail.map((row, index) => {
          if (isNumeric(row["vac_value"])) {
            let value = Number(row["vac_value"]);
            if (row["vac_taxname"] && row["vac_calculation"] == "+") {
              totalBeforeTaxAmt += value;
              let result = this.taxCalcualte(
                row,
                "+",
                tblCGST,
                tblSGST,
                plustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              plustblIGST = Number(result.tblIGST);
            } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
              totalBeforeTaxAmt -= value;
              let result = this.taxCalcualte(
                row,
                "-",
                tblCGST,
                tblSGST,
                minustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              minustblIGST = Number(result.tblIGST);
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "+"
            ) {
              totalAfterTaxAmt += value;
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "-"
            ) {
              totalAfterTaxAmt -= value;
            }
          }
        });

        let tblIGST = Number(plustblIGST) + Number(minustblIGST);
        this.setState(
          {
            rowsOtherDetail,
            rowsCountOtherDetail: rowsOtherDetail.length,
            totalBeforeTaxAmt,
            totalAfterTaxAmt,
            formData: {
              ...this.state.formData,
              tblCGST: Number(tblCGST),
              tblSGST: Number(tblSGST),
              tblIGST: Number(tblIGST),
              txtCGST: 0,
              txtSGST: 0,
              txtIGST: 0,
            },
          },
          () => {}
        );
        // console.log("rowsOtherDetail", rowsOtherDetail);
      }
    );
  };
  handleOnRowDataChangeOtherDetail1 = (
    rowsOtherDetail1,
    handledRowIndex,
    colID
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: 0,
          tblSGST: 0,
          tblIGST: 0,
        },
      },
      () => {
        let totalBeforeTaxAmt = 0;
        let totalAfterTaxAmt = 0;
        let tblCGST = 0,
          tblSGST = 0,
          minustblIGST = 0,
          plustblIGST = 0;

        if (isNumeric(this.state.formData.tblCGST)) {
          tblCGST = Number(this.state.formData.tblCGST);
        }
        if (isNumeric(this.state.formData.tblSGST)) {
          tblSGST = Number(this.state.formData.tblSGST);
        }
        if (isNumeric(this.state.formData.tblIGST)) {
          minustblIGST = Number(this.state.formData.tblIGST);
          plustblIGST = Number(this.state.formData.tblIGST);
        }
        rowsOtherDetail1.map((row, index) => {
          if (isNumeric(row["vac_value"])) {
            let value = Number(row["vac_value"]);
            if (row["vac_taxname"] && row["vac_calculation"] == "+") {
              totalBeforeTaxAmt += value;
              let result = this.taxCalcualte(
                row,
                "+",
                tblCGST,
                tblSGST,
                plustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              plustblIGST = Number(result.tblIGST);
            } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
              totalBeforeTaxAmt -= value;
              let result = this.taxCalcualte(
                row,
                "-",
                tblCGST,
                tblSGST,
                minustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              minustblIGST = Number(result.tblIGST);
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "+"
            ) {
              totalAfterTaxAmt += value;
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "-"
            ) {
              totalAfterTaxAmt -= value;
            }
          }
        });

        let tblIGST = Number(plustblIGST) + Number(minustblIGST);
        this.setState(
          {
            rowsOtherDetail1,
            rowsCountOtherDetail1: rowsOtherDetail1.length,
            totalBeforeTaxAmt,
            totalAfterTaxAmt,
            formData: {
              ...this.state.formData,
              tblCGST: Number(tblCGST),
              tblSGST: Number(tblSGST),
              tblIGST: Number(tblIGST),
              txtCGST: 0,
              txtSGST: 0,
              txtIGST: 0,
            },
          },
          () => {}
        );
        // console.log("rowsOtherDetail", rowsOtherDetail);
      }
    );
  };
  taxCalcualte = (row, icon, tblCGST, tblSGST, tblIGST) => {
    if (isNumeric(row["vac_value"])) {
      let value = Number(row["vac_value"]);
      if (row["vac_taxname"].length > 0) {
        const txtTaxable = value,
          TaxName = getTaxNumFromStr(row["vac_taxname"]);

        if (Number(txtTaxable) != 0 && Number(TaxName) >= 0) {
          tblCGST =
            icon == "+"
              ? tblCGST + (txtTaxable * (TaxName / 2)) / 100
              : tblCGST - (txtTaxable * (TaxName / 2)) / 100;
          tblCGST = Number(tblCGST);
          tblCGST = tblCGST.toFixed(2);
          tblSGST = tblCGST;

          if (
            this.state.SupplierStateCode !=
            localStorage.getItem("CompStateCode")
          ) {
            tblIGST = Number(tblCGST) + Number(tblSGST);
            tblCGST = 0;
            tblSGST = 0;
          }
        }
      }
    }
    return { tblCGST, tblSGST, tblIGST };
  };

  handleOnRowDataChangePaymentMode = (
    rowsPaymentMode,
    handledRowIndex,
    colID
  ) => {
    this.setState({
      rowsPaymentMode,
      rowsCountPaymentMode: rowsPaymentMode.length,
    });
  };
  //#endregion handle

  //#region function
  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "Lbl",
        label: "Sr. No.",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_storename",
        // items: this.state.ItemName,
        label: "Store Name",
        value: this.state.searchData.vac_storename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "120",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_itemname",
        maxLength: "100",
        // items: this.state.ItemName,
        label: "Item Name",
        value: this.state.searchData.vac_itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "120",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_unit",
        // items: this.state.Packing,
        label: "Packing",
        value: this.state.searchData.vac_unit,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "dec_qty",
        label: "Quantity",
        value: this.state.searchData.dec_qty,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_rate",
        label: "Rate",
        value: this.state.searchData.dec_rate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_basicamt",
        label: "Basic Amount",
        value: this.state.searchData.dec_basicamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        label: "Dis (%)",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Dis Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Taxable",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_taxname",
        // items: this.state.TaxName,
        label: "Tax Name",
        value: this.state.searchData.vac_taxname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        // colID: 'status',
      },
      {
        cType: "Lbl",
        id: "dec_cgstamt",
        label: "CGST",
        value: this.state.searchData.dec_cgstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_sgstamt",
        label: "SGST",
        value: this.state.searchData.dec_sgstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_igstamt",
        label: "IGST",
        value: this.state.searchData.dec_igstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_totalamt",
        label: "Total amt",
        value: this.state.searchData.dec_totalamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts(
        this.savePurchase,
        this.clearInfo,
        () => {
          this.onDeleteBtnClick();
        }
      ),
    });
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({ formData: this.state.formData });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validatePurchase = () => {
    let result = false;
    // console.log(applyTrimOnObjectValues(this.state.formData,['cmbSupplier']))
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return false;
    } else if (this.state.formData.txtBillNo.length <= 0) {
      this.props.toastErrorMsg("Enter Bill No", "txtBillNo");
    } else if (this.state.formData.cmbSupplier.length <= 0) {
      this.props.toastErrorMsg("Select Supplier Name", "cmbSupplier");
    } else if (
      isValidItem(
        this.state.SupplierList,
        "vac_supplier",
        this.state.formData.cmbSupplier
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Supplier Name", "cmbSupplier");
    } else if (this.state.formData.cmbTransactionType.length <= 0) {
      this.props.toastErrorMsg("Select Transaction Type", "cmbTransactionType");
    } else {
      result = true;
    }
    return result;
  };

  validatePurchaseItemCount = () => {
    let result = false;
    if (this.state.rowsCount <= 0) {
      this.props.toastErrorMsg("Enter atleast one item", "dtpDate");
    } else {
      result = true;
    }
    return result;
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    if (
      this.getPaymentModeDataStatus &&
      this.state.rowsPaymentMode.length > 0
    ) {
      this.state.rowsPaymentMode.map((row) => {
        if (row.dec_amount != undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      if (this.state.formData.cmbTransactionType === "Paid") {
        if (Number(dec_amount) == Number(this.state.formData.txtNetPayment)) {
          result = true;
        } else {
          this.props.toastErrorMsg(
            "Net Payment Amount and Payment Mode Ledger Amount must be same",
            "txtNetPayment"
          );
        }
      } else if (this.state.formData.cmbTransactionType === "Remain") {
        if (Number(dec_amount) == Number(this.state.formData.txtAdvPayment)) {
          result = true;
        } else {
          this.props.toastErrorMsg(
            "Advance Amount and Payment Mode Ledger Amount must be same",
            "txtNetPayment"
          );
        }
      }
    } else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState(
      {
        dataLoadStatus,
        rows: [],
        rowsCount: 0,
        rowsOtherDetail: [],
        rowsOtherDetail1: [],
        rowsCountOtherDetail: 0,
        rowsCountOtherDetail1: 0,
        rowsPaymentMode: [],
        rowsCountPaymentMode: 0,
        LedgerNameList: [],
        DetailList: [],
      },
      () => {
        // console.log("this.props.location", this.props.location);
        // console.log("this.props.location.state", this.props.location.state);
        let bint_acyear = 0,
          bint_acid = "",
          edit_purchasesrno = 0;
        if (this.props.location.state && this.props.location.state != null) {
          // var editInfo = this.props.params.EditPurchaseSrNo.split(":");
          bint_acid = this.props.location.state.bint_acid;
          edit_purchasesrno = this.props.location.state.bint_purchaseno;
          bint_acyear = this.props.location.state.bint_acyear;
          let reqData = {
            Op: "PurchaseData",
            bint_acyear,
            bint_acid,
            edit_purchaseno: edit_purchasesrno,
          };
          fetchPurchase(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let SupplierList = res.data.supplierList,
                TaxNameList = res.data.TaxList,
                ItemNameList = res.data.ItemList,
                StoreList = res.data.StoreList,
                DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                PurchaseInvoiceGeneration = [],
                rowsOtherDetail = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsOtherDetail1 = [],
                rowsCountOtherDetail1 = rowsOtherDetail1.length,
                rows = [],
                rowsCount = rows.length,
                rowsPaymentMode = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                LedgerNameList = [],
                DetailList = [],
                PaymentData = [];
              if (
                res.data.PurchaseItemData &&
                res.data.PurchaseItemData.length > 0
              ) {
                rows = res.data.PurchaseItemData;
                rowsCount = rows.length;
              }
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = copyRowsAllCols(
                  res.data.LedgerNameList,
                  this.state.PaymentmodeListCols
                );
                LedgerNameList = copyRowsAllCols(
                  res.data.LedgerNameList,
                  this.state.PaymentmodeListCols
                );
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                PaymentData = res.data.PaymentData;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail = res.data.DetailList.map((row) => {
                  return {
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                  };
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail = rowsOtherDetail.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail1 = res.data.DetailList.map((row) => {
                  return {
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                  };
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }
              if (
                res.data.OtherDetailData &&
                res.data.OtherDetailData.length > 0
              ) {
                res.data.OtherDetailData.map((odd) => {
                  let isFound = 0;
                  rowsOtherDetail.map((rod) => {
                    if (rod.vac_headingvalue === odd.vac_headingvalue) {
                      rod.vac_value = odd.vac_value;
                      isFound++;
                    }
                  });
                  if (isFound === 0) {
                    rowsOtherDetail.push({
                      vac_headingvalue: odd.vac_headingvalue,
                      vac_value: odd.vac_value,
                      bint_displayorderno: rowsOtherDetail.length + 1,
                    });
                  }
                });
                rowsCountOtherDetail = rowsOtherDetail.length;
              }

              if (
                res.data.OtherDetailData &&
                res.data.OtherDetailData.length > 0
              ) {
                res.data.OtherDetailData.map((odd) => {
                  let isFound = 0;
                  rowsOtherDetail1.map((rod) => {
                    if (rod.vac_headingvalue === odd.vac_headingvalue) {
                      rod.vac_value = odd.vac_value;
                      isFound++;
                    }
                  });
                  if (isFound === 0) {
                    rowsOtherDetail1.push({
                      vac_headingvalue: odd.vac_headingvalue,
                      vac_value: odd.vac_value,
                      bint_displayorderno: rowsOtherDetail1.length + 1,
                    });
                  }
                });
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }

              if (
                res.data.GeneralSettingList &&
                res.data.GeneralSettingList.length > 0
              ) {
                PurchaseInvoiceGeneration =
                  res.data.GeneralSettingList[0].vac_value;
              }
              // console.log("DetailList", DetailList);
              // console.log("rowsOtherDetail", rowsOtherDetail);
              this.setState({
                dataLoadStatus: true,
                SupplierList,
                TaxNameList,
                ItemNameList,
                DefaultEntrySettingList,
                StoreList,
                PurchaseInvoiceGeneration,
                rows,
                rowsCount,
                rowsOtherDetail,
                rowsCountOtherDetail,
                rowsOtherDetail1,
                rowsCountOtherDetail1,
                rowsPaymentMode,
                rowsCountPaymentMode,
                LedgerNameList,
                DetailList,
                PaymentData,
                totalAfterTaxAmt: res.data.PurchaseList[0].dec_aftertaxamt,
                totalBeforeTaxAmt: res.data.PurchaseList[0].dec_beforetaxamt,
                formData: {
                  ...this.state.formData,
                  edit_purchasesrno: res.data.PurchaseList[0].bint_purchaseno,
                  dtpDate: res.data.PurchaseList[0].dat_purchasedate,
                  cmbCompany: res.data.PurchaseList[0].vac_company,
                  txtBillNo: res.data.PurchaseList[0].vac_billno,
                  cmbSupplier: res.data.PurchaseList[0].vac_supplier,
                  // beforTax: res.data.PurchaseList[0].dec_beforetaxamt,
                  // afterTax: res.data.PurchaseList[0].dec_aftertaxamt,
                  txtDiscount: res.data.PurchaseList[0].dec_discamt,
                  txtTaxable: res.data.PurchaseList[0].dec_taxableamount,
                  txtCGST: res.data.PurchaseList[0].dec_cgst,
                  txtSGST: res.data.PurchaseList[0].dec_sgst,
                  txtIGST: res.data.PurchaseList[0].dec_igst,
                  txtGrandTotal: res.data.PurchaseList[0].dec_grandtotal,
                  txtAdvPayment: res.data.PurchaseList[0].dec_advpay,
                  txtNetPayment: res.data.PurchaseList[0].dec_netpay,
                  txtRoundOff: res.data.PurchaseList[0].dec_roundoff,
                  cmbTransactionType:
                    res.data.PurchaseList[0].vac_transactiontype,
                  txtRemark: res.data.PurchaseList[0].vac_remark,
                },
              });
            })
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error
              );
            });
        } else {
          const reqData = {
            Op: "PurchaseData",
            bint_acid: localStorage.getItem("acid"),
            bint_acyear: localStorage.getItem("ACY"),
          };
          fetchPurchase(reqData)
            .then((res) => {
              dataLoadStatus = true;
              let SupplierList = [],
                TaxNameList = [],
                ItemNameList = [],
                StoreList = [],
                PurchaseInvoiceGeneration = [],
                InvoiceNoList = [],
                DefaultEntrySettingList = [],
                cmbTransactionType = "",
                rowsOtherDetail = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsOtherDetail1 = [],
                rowsCountOtherDetail1 = rowsOtherDetail1.length,
                rowsPaymentMode = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                LedgerNameList = [],
                DetailList = [],
                PaymentData = [];

              if (res.data.supplierList && res.data.supplierList.length > 0) {
                SupplierList = res.data.supplierList;
              }
              if (res.data.TaxList && res.data.TaxList.length > 0) {
                TaxNameList = res.data.TaxList;
              }
              if (res.data.ItemList && res.data.ItemList.length > 0) {
                ItemNameList = res.data.ItemList;
              }
              if (res.data.StoreList && res.data.StoreList.length > 0) {
                StoreList = res.data.StoreList;
              }
              if (
                res.data.GeneralSettingList &&
                res.data.GeneralSettingList.length > 0
              ) {
                PurchaseInvoiceGeneration =
                  res.data.GeneralSettingList[0].vac_value;
              }
              if (res.data.InvoiceNoList && res.data.InvoiceNoList.length > 0) {
                InvoiceNoList = res.data.InvoiceNoList;
              }
              if (
                res.data.DefaultEntrySettingList &&
                res.data.DefaultEntrySettingList.length > 0
              ) {
                DefaultEntrySettingList = res.data.DefaultEntrySettingList;
              }
              if (DefaultEntrySettingList.length > 0) {
                cmbTransactionType =
                  DefaultEntrySettingList[0].vac_transacationtype;
              }
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = copyRowsAllCols(
                  res.data.LedgerNameList,
                  this.state.PaymentmodeListCols
                );
                LedgerNameList = copyRowsAllCols(
                  res.data.LedgerNameList,
                  this.state.PaymentmodeListCols
                );
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail = res.data.DetailList.map((row) => {
                  return {
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                  };
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail = rowsOtherDetail.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail1 = res.data.DetailList.map((row) => {
                  return {
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                  };
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }
              if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                PaymentData = res.data.PaymentData;
              }
              this.setState(
                {
                  dataLoadStatus,
                  SupplierList,
                  TaxNameList,
                  ItemNameList,
                  StoreList,
                  PurchaseInvoiceGeneration,
                  BillNoList: InvoiceNoList,
                  DefaultEntrySettingList,
                  LedgerNameList,
                  DetailList,
                  PaymentData,
                  formData: {
                    ...this.state.formData,
                    cmbTransactionType,
                  },
                  rowsOtherDetail,
                  rowsOtherDetail1,
                  rowsCountOtherDetail: rowsOtherDetail.length,
                  rowsCountOtherDetail1: rowsOtherDetail1.length,
                  rowsPaymentMode,
                  rowsCountPaymentMode,
                },
                () => {
                  // this.getDefaultBillType()
                  // console.log("this.state", this.state);
                }
              );
            })
            .catch((error) => {
              console.log("Unknown error occurred in onFormLoad.", error);
            });
        }
      }
    );
    document.getElementById("dtpDate").focus();
  };

  clearInfo = () => {
    let cmbTransactionType = "";
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      cmbTransactionType =
        this.state.DefaultEntrySettingList[0].vac_transacationtype;
    }
    // console.log("this.state.DetailList", this.state.DetailList);
    // console.log("this.state.LedgerNameList", this.state.LedgerNameList);
    this.setState(
      {
        totalAfterTaxAmt: "",
        totalBeforeTaxAmt: "",
        formData: {
          ...this.state.formData,
          edit_purchasesrno: "",
          dtpDate: get_YMD_from_SYS(new Date()),
          cmbSupplier: "",
          txtBillNo: "",
          txtDiscountAmount: "",
          txtTaxable: "",
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          tblCGST: "",
          tblSGST: "",
          tblIGST: "",
          txtGrandTotal: "",
          txtAdvPayment: "",
          txtRoundOff: "",
          txtNetPayment: "",
          cmbTransactionType,
          txtRemark: "",
        },
        rows: [],
        rowsCount: 0,
        rowsOtherDetail: this.state.rowsOtherDetail,
        rowsCountOtherDetail: this.state.rowsOtherDetail.length,
        rowsOtherDetail1: this.state.rowsOtherDetail1,
        rowsCountOtherDetail1: this.state.rowsOtherDetail1.length,
        rowsPaymentMode: copyRowsAllCols(
          this.state.LedgerNameList,
          this.state.PaymentmodeListCols
        ),
        rowsCountPaymentMode: this.state.LedgerNameList.length,
        PaymentData: [],
      },
      () => {
        document.getElementById("dtpDate").focus();
        this.props.navigateTo("PurchaseEntry");
      }
    );
  };

  savePurchase = () => {
    if (
      this.validatePurchase() &&
      this.validatePurchaseItemCount() &&
      this.validatePaymentModeAmount()
    ) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      let rowsTotal = getRowColSum(this.state.rows, [
        "dec_cgstamt",
        "dec_sgstamt",
        "dec_igstamt",
      ]);

      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SavePurchase_Item",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          bint_purchaseno: this.state.formData.edit_purchasesrno,
          dat_purchasedate: this.state.formData.dtpDate,
          vac_billtype: this.state.formData.cmbBillType,
          vac_billno: this.state.formData.txtBillNo,
          vac_supplier: this.state.formData.cmbSupplier,
          dec_discamt: this.state.formData.txtDiscount,
          dec_taxableamount: this.state.formData.txtTaxable,
          dec_cgst: this.state.formData.txtCGST,
          dec_sgst: this.state.formData.txtSGST,
          dec_igst: this.state.formData.txtIGST,
          dec_grandtotal: this.state.formData.txtGrandTotal,
          dec_advpay: this.state.formData.txtAdvPayment,
          dec_roundoff: this.state.formData.txtRoundOff,
          dec_netpay: this.state.formData.txtNetPayment,
          vac_transactiontype: this.state.formData.cmbTransactionType,
          bint_vouno: 0,
          vac_remark: this.state.formData.txtRemark,
          PaymentData: this.getPaymentModeDataStatus()
            ? this.state.rowsPaymentMode
            : [],
          OtherDetailData: this.state.rowsOtherDetail,
          OtherDetailData1: this.state.rowsOtherDetail1,
          dec_beforetaxamt: this.state.totalBeforeTaxAmt,
          dec_aftertaxamt: this.state.totalAfterTaxAmt,
          bint_ci: localStorage.getItem("CI"),
        };
        fetchPurchase(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                cmbTransactionType = "",
                rowsOtherDetail = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsOtherDetail1 = [],
                rowsCountOtherDetail1 = rowsOtherDetail1.length,
                rowsPaymentMode = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                StoreList = [],
                PurchaseInvoiceGeneration = [],
                LedgerNameList = [],
                DetailList = [],
                SupplierList = [],
                ItemNameList = [],
                TaxNameList = [];
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                LedgerNameList = res.data.LedgerNameList;
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                DetailList = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsOtherDetail = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsCountOtherDetail = rowsOtherDetail.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                DetailList = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsOtherDetail1 = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsCountOtherDetail = rowsOtherDetail1.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                DetailList = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsOtherDetail1 = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }
              if (DefaultEntrySettingList.length > 0) {
                cmbTransactionType =
                  DefaultEntrySettingList[0].vac_transacationtype;
              }
              if (res.data.StoreList.length > 0) {
                StoreList = res.data.StoreList;
              }
              if (res.data.TaxList.length > 0) {
                TaxNameList = res.data.TaxList;
              }
              if (res.data.ItemList.length > 0) {
                ItemNameList = res.data.ItemList;
              }
              if (res.data.supplierList.length > 0) {
                SupplierList = res.data.supplierList;
              }
              // console.log("rowsPaymentMode", rowsPaymentMode);
              // console.log("rowsOtherDetail", rowsOtherDetail);
              this.setState(
                {
                  dataLoadStatus: true,
                  StoreList,
                  LedgerNameList,
                  DetailList,
                  SupplierList,
                  ItemNameList,
                  TaxNameList,
                  DefaultEntrySettingList,
                  formData: {
                    ...this.state.formData,
                    cmbTransactionType,
                  },
                  // rowsOtherDetail,
                  // rowsCountOtherDetail,
                  // rowsPaymentMode,
                  // rowsCountPaymentMode,
                },
                () => {
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in savePurchase.", error);
          });
      });
    }
  };

  onDeleteBtnClick = () => {
    if (this.state.formData.edit_purchasesrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Bill No. : " +
              this.state.formData.txtBillNo +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deletePurchase(this.state.formData.edit_purchasesrno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no Purchase to delete", "dtpDate");
    }
  };

  deletePurchase = (edit_purchasesrno) => {
    if (edit_purchasesrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeletePurchase",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_purchaseno: edit_purchasesrno,
          dat_fromdate: "",
          dat_todate: "",
        };
        fetchPurchase(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in delete deletePurchase. " + error
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no Purchase records to delete."
      );
    }
  };

  deletePurchaseItem = (
    bint_acyear,
    bint_acid,
    edit_purchasesrno,
    bint_itemsrno
  ) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      this.props.notifyProcessing();
      const reqData = {
        Op: "DeletePurchaseItem",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_purchaseno: edit_purchasesrno,
        edit_itemsrno: bint_itemsrno,
        dec_advpay: this.state.formData.txtAdvPayment,
        dec_roundoff: this.state.formData.txtRoundOff,
        vac_supplier: this.state.formData.cmbSupplier,
        bint_ci: localStorage.getItem("CI"),
        dat_purchasedate: this.state.formData.dtpDate,
        vac_remark: this.state.formData.txtRemark,
        vac_transactiontype: this.state.formData.cmbTransactionType,
        PaymentData: this.state.rowsPaymentMode,
        vac_billno: this.state.formData.txtBillNo,
      };
      console.log("reqData", reqData);
      fetchPurchase(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          let dec_basicamt = 0,
            dec_disamt = 0,
            dec_taxable = 0,
            dec_cgstamt = 0,
            dec_sgstamt = 0,
            dec_igstamt = 0,
            dec_totalamt = 0,
            PurchaseItemData = [];
          if (
            res.data.PurchaseItemData &&
            res.data.PurchaseItemData.length > 0
          ) {
            rows = res.data.PurchaseItemData;
            rowsCount = rows.length;
          }
          if (res.data.TotalItemAmountData) {
            dec_basicamt = Number(res.data.TotalItemAmountData[0].dec_basicamt);
            dec_disamt = Number(res.data.TotalItemAmountData[0].dec_disamt);
            dec_taxable = Number(
              res.data.TotalItemAmountData[0].dec_taxableamount
            );
            dec_cgstamt = Number(res.data.TotalItemAmountData[0].dec_cgstamt);
            dec_sgstamt = Number(res.data.TotalItemAmountData[0].dec_sgstamt);
            dec_igstamt = Number(res.data.TotalItemAmountData[0].dec_igstamt);
            dec_totalamt = Number(
              res.data.TotalItemAmountData[0].dec_totalamount
            );
          }
          this.resetAmount(
            dec_taxable,
            dec_cgstamt,
            dec_sgstamt,
            dec_igstamt,
            dec_totalamt,
            dec_disamt,
            edit_purchasesrno
          );
          this.setState({
            ARD: null,
            rows,
            rowsCount,
            dataLoadStatus,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in deletePurchaseItem.", error);
        });
    });
    return true;
  };

  refreshPurchaseItemList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  resetAmount = (
    txtTaxable,
    txtCGST,
    txtSGST,
    txtIGST,
    txtGrandTotal,
    txtDiscount,
    edit_purchasesrno
  ) => {
    // console.log("resetAmount", txtTaxable, txtCGST, txtSGST, txtIGST);
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtTaxable,
          txtCGST,
          txtSGST,
          txtIGST,
          txtGrandTotal,
          txtDiscount,
          edit_purchasesrno,
        },
      },
      () => {
        // console.log("this.state.formData", this.state.formData);
        this.calNetAmount();
      }
    );
  };

  calNetAmount = () => {
    let txtNetPayment =
        Number(this.state.formData.txtGrandTotal) -
        Number(this.state.formData.txtAdvPayment),
      txtRoundOff = 0;
    let arrNetPayment = getRoundOff(txtNetPayment);
    txtNetPayment = arrNetPayment["roff_number"];
    txtRoundOff = arrNetPayment["roff"];
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtNetPayment,
          txtRoundOff,
        },
      },
      () => {
        // console.log("this.state.formData", this.state.formData);
      }
    );
  };

  getStateCodeOFPurchase = () => {
    if (this.state.formData.cmbSupplier.length > 0) {
      let SupplierStateCode = 0;
      this.state.SupplierList.map((row) => {
        if (row.vac_supplier === this.state.formData.cmbSupplier) {
          SupplierStateCode = row.vac_statecode;
          this.setState({
            SupplierStateCode: row.vac_statecode,
          });
        }
      });
      // console.log("SupplierStateCode", SupplierStateCode);
      if (SupplierStateCode != localStorage.getItem("CompStateCode")) {
        let rowsTotal = getRowColSum(this.state.rows, [
          "dec_cgstamt",
          "dec_sgstamt",
          "dec_igstamt",
        ]);
        let CGST =
          Number(this.state.formData.txtCGST) != 0
            ? Number(this.state.formData.txtCGST)
            : Number(rowsTotal.dec_cgstamt) +
              Number(this.state.formData.tblCGST);
        let SGST =
          Number(this.state.formData.txtSGST) != 0
            ? Number(this.state.formData.txtSGST)
            : Number(rowsTotal.dec_sgstamt) +
              Number(this.state.formData.tblSGST);
        let IGST =
          Number(this.state.formData.txtIGST) != 0
            ? Number(this.state.formData.txtIGST)
            : Number(rowsTotal.dec_igstamt) +
              Number(this.state.formData.tblIGST);
        console.log("CGST SGST IGST", CGST, SGST, IGST);
      } else if (SupplierStateCode == localStorage.getItem("CompStateCode")) {
        let rowsTotal = getRowColSum(this.state.rows, [
          "dec_cgstamt",
          "dec_sgstamt",
          "dec_igstamt",
        ]);
        let IGST =
          Number(this.state.formData.txtIGST) != 0
            ? Number(this.state.formData.txtIGST)
            : Number(rowsTotal.dec_igstamt) +
              Number(this.state.formData.tblIGST);

        let CGST = IGST / 2;

        let SGST = IGST / 2;

        IGST = 0;

        console.log("CGST SGST IGST", CGST, SGST, IGST);
      }
    }
  };

  getSupplierList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadSupplierDetails",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchSupplierMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Supplier List Loaded");
        let SupplierList = res.data.supplierList;
        this.setState(
          {
            SupplierList,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getPurchaseList.", error);
      });
  };

  getDetailList = () => {
    // console.log("dtail list");
    this.props.notifyProcessing();
    const reqData = {
      Op: "DetailList",
      bint_acid: localStorage.getItem("acid"),
      vac_detailtype: "",
    };
    fetchDetailMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Detial List Loaded");
        let rowsOtherDetail = res.data.DetailList,
          rowsCountOtherDetail = 0;
        let rowsOtherDetail1 = res.data.DetailList,
          rowsCountOtherDetail1 = 0;
        this.setState({
          rowsOtherDetail,
          rowsCountOtherDetail,
          rowsOtherDetail1,
          rowsCountOtherDetail1,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in getDetailList.", error);
      });
  };

  onAddClickSupplier = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<SupplierMaster />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.ShortCut();
            this.getSupplierList();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getItemList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ItemList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchItemMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Item List Loaded");
        let ItemNameList = res.data.ItemList;
        this.setState(
          {
            ItemNameList,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getItemList.", error);
      });
  };

  getPayRemarkLblVisibleStatus = () => {
    return this.state.formData.cmbTransactionType == "Remain" &&
      Number(this.state.formData.txtAdvPayment) > 0
      ? true
      : false;
  };

  getPaymentModeDataStatus = () => {
    let result = false;
    if (
      this.state.formData.cmbTransactionType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
    ) {
      result = true;
    } else {
      this.state.rowsPaymentMode.map((row) => {
        // row.vac_ledgername = ''
        row.dec_amount = "";
        row.vac_chequeno = "";
        row.vac_referenceno = "";
        row.dat_transactiondate = "";
        row.vac_remark = "";
      });
    }
    return result;
    /* return this.state.formData.cmbTransactionType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
      ? true
      : false; */
  };

  setSaveBtnDisplay = () => {
    let isParamFound =
      this.props.params &&
      this.props.params.EditPurchaseSrNo &&
      this.props.params.EditPurchaseSrNo.substring(1).length > 0;
    if (isParamFound !== true) {
      isParamFound = false;
    }
    let paramEditPurchaseSrNo = 0;
    if (isParamFound) {
      var editInfo = this.props.params.EditPurchaseSrNo.split(":");
      paramEditPurchaseSrNo = Number(editInfo[2]);
      if (paramEditPurchaseSrNo <= 0) {
        isParamFound = false;
      }
    }
    if (this.props.userPrivilege.Purchase == "M") {
      return "block";
    } else if (this.props.userPrivilege.Purchase == "R") {
      return "none";
    } else if (
      (this.props.userPrivilege.Purchase == "W" &&
        Number(this.state.formData.edit_purchasesrno) > Number(0) &&
        isParamFound === false) ||
      (this.props.userPrivilege.Purchase == "W" &&
        Number(this.state.formData.edit_purchasesrno) > Number(0) &&
        isParamFound === true &&
        Number(this.state.formData.edit_purchasesrno) !==
          Number(paramEditPurchaseSrNo)) ||
      (this.props.userPrivilege.Purchase == "W" &&
        Number(this.state.formData.edit_purchasesrno) <= Number(0))
    ) {
      return "block";
    } else {
      return "none";
    }
  };

  setPaymentData = (rowsPaymentMode) => {
    this.setState(
      {
        rowsPaymentMode,
      },
      () => {
        // console.log("this.state.rows", this.state.rows);
      }
    );
  };

  getDefaultEntrySettingRow = () => {
    let DefaultEntrySettingList = [];
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      if (
        this.state.DefaultEntrySettingList[0].vac_transacationtype == "Paid"
      ) {
        DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
      } else {
        if (
          this.state.DefaultEntrySettingList[1].vac_transacationtype == "Paid"
        ) {
          DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
        }
      }
    }
    return DefaultEntrySettingList;
  };

  getEnabledAdvPaymentStatus = () => {
    if (this.state.formData.cmbTransactionType === "Paid") {
      return false;
    } else {
      return true;
    }
  };

  openRichTextBox = (Heading, id, TxtChange) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set"
          fullscreenOnly={true}
          alertIcon=""
          alertTitle={Heading}
          alertMessage={
            <MoreInfoTextEditor
              TxtChange={TxtChange}
              Txtid={id}
              updateDetails={this.updateDetails}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  updateDetails = (id, Details) => {
    let txtRemark = this.state.formData.txtRemark;

    if (id === "Remark") {
      txtRemark = Details;
    }

    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtRemark,
        },
      },
      () => {}
    );
  };

  //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    let isPaymodePaid = this.getPaymentModeDataStatus();
    const isDisplaySaveBtn = this.setSaveBtnDisplay();
    let DefaultEntrySettingList = this.getDefaultEntrySettingRow();
    const txtAmount4PaymentModeTable =
      this.state.formData.cmbTransactionType === "Paid"
        ? Number(this.state.formData.txtNetPayment)
        : Number(this.state.formData.txtAdvPayment);
    // console.log("SupplierList", this.state.SupplierList);

    let rowsTotal = getRowColSum(this.state.rows, [
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
    ]);

    // console.log("rowsTotal", rowsTotal);

    let CGST =
      Number(this.state.formData.txtCGST) != 0
        ? Number(this.state.formData.txtCGST)
        : Number(rowsTotal.dec_cgstamt) + Number(this.state.formData.tblCGST);
    let SGST =
      Number(this.state.formData.txtSGST) != 0
        ? Number(this.state.formData.txtSGST)
        : Number(rowsTotal.dec_sgstamt) + Number(this.state.formData.tblSGST);
    let IGST =
      Number(this.state.formData.txtIGST) != 0
        ? Number(this.state.formData.txtIGST)
        : Number(rowsTotal.dec_igstamt) + Number(this.state.formData.tblIGST);
    let txtGrandTotal =
      Number(this.state.formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt) +
      CGST +
      SGST +
      IGST +
      Number(this.state.totalAfterTaxAmt);

    txtGrandTotal = txtGrandTotal.toFixed(2);
    let NetPayment =
      Number(txtGrandTotal) - Number(this.state.formData.txtAdvPayment);

    let arrNetPayment = getRoundOff(NetPayment);
    NetPayment = arrNetPayment["roff_number"];
    let txtRoundOff = arrNetPayment["roff"];

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Purchase Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="flex-start"
          spacing={0}
          marginTop={0}
        >
          <Grid item sm={12} lg={6}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtDtp
                  id="dtpDate"
                  label="Date"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpDate}
                  value={this.state.formData.dtpDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtBillNo"
                  label="Bill No*"
                  // disabled={true}
                  value={this.state.formData.txtBillNo}
                  handleOnChange={this.handleOnChange}
                  width={125}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbSupplier"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbSupplier"
                  label="Supplier*"
                  items={getRowColData(this.state.SupplierList, "vac_supplier")}
                  value={this.state.formData.cmbSupplier}
                  handleOnChange={this.handleOnChange}
                  width={250}
                  maxLength={100}
                  colID="vac_supplier"
                  onAddClick={this.onAddClickSupplier}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtAdvPayment"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtDiscountAmount"
                  label="Dis. Amount"
                  disabled={true}
                  value={this.state.formData.txtDiscountAmount}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtTaxable"
                  label="Taxable"
                  disabled={true}
                  value={this.state.formData.txtTaxable}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="beforTax"
                  label="Before Tax Amount"
                  handleOnChange={this.handleOnChange}
                  width={140}
                  maxLength={10}
                  disabled={true}
                  value={this.state.totalBeforeTaxAmt}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtCGST"
                  label="CGST"
                  disabled={true}
                  value={CGST}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtSGST"
                  label="SGST"
                  disabled={true}
                  value={SGST}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtIGST"
                  label="IGST"
                  disabled={true}
                  value={IGST}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="afterTax"
                  label="After Tax Amount"
                  handleOnChange={this.handleOnChange}
                  width={140}
                  maxLength={10}
                  disabled={true}
                  value={this.state.totalAfterTaxAmt}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtGrandTotal"
                  label="Grand Total"
                  disabled={true}
                  value={txtGrandTotal}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtAdvPayment"
                  label="Adv Payment"
                  disabled={!this.getEnabledAdvPaymentStatus()}
                  value={this.state.formData.txtAdvPayment}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbTransactionType"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtRoundOff"
                  label="R.Off"
                  value={txtRoundOff}
                  handleOnChange={this.handleOnChange}
                  width={60}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtNetPayment"
                  label="Net Payment"
                  disabled={true}
                  value={NetPayment}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmb
                  id="cmbTransactionType"
                  label="Transaction Type*"
                  items={this.state.TransactionType}
                  value={this.state.formData.cmbTransactionType}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={100}
                  colID="name"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtRemark"
                />
              </Grid>
              {/* <Grid item>
                <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  value={this.state.formData.txtRemark}
                  handleOnChange={this.handleOnChange}
                  width={400}
                  maxLength={1000}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid> */}
              {/* <Grid item xs={12} sm={11}> */}
              {/* <CtMultiLineText
                                id="txtRemark"
                                label="Remark"
                                value={this.state.formData.txtRemark}
                                handleOnChange={this.handleOnChange}
                                width={"100%"}
                                maxLength={500}
                              /> */}
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <p
                  style={{
                    color: "#666666",
                    margin: "0",
                    padding: "0",
                    fontSize: "14px",
                  }}
                >
                  Remark
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "0",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.formData.txtRemark,
                    }}
                    style={{ margin: "0", padding: "0" }}
                  />
                  <div style={{ margin: "0", padding: "0" }}>
                    <Edit
                      className={"child-button"}
                      style={{
                        border: "none",
                        cursor: "pointer",
                        // color: "#4687FF",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                </div>
              </Grid>
              {/* </Grid> */}
            </Grid>
            {isPaymodePaid === false ? (
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item display={isDisplaySaveBtn}>
                  <CtBtn
                    label="Save"
                    onClick={() => {
                      this.trimFormData(() => {
                        this.savePurchase();
                      });
                    }}
                  />
                </Grid>
                <Grid item>
                  <CtBtn label="New" onClick={this.clearInfo} />
                </Grid>
                <Grid
                  item
                  display={
                    this.props.userPrivilege.Purchase !== "M" ? "none" : "block"
                  }
                >
                  <CtBtn label="Delete" onClick={this.onDeleteBtnClick} />
                </Grid>
                <Grid item>
                  <CtBtn
                    label="Purchase List"
                    onClick={() => {
                      this.props.navigateTo("PurchaseList");
                    }}
                  />
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
          <Grid item sm={12} lg={6}>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                {this.state.formData.cmbSupplier.length > 0 ? (
                  <TableList
                    columns={this.state.columnsOtherDetail}
                    counter={this.state.counter}
                    rows={this.state.rowsOtherDetail}
                    rowsCount={this.state.rowsCountOtherDetail}
                    rowsPerPage={this.state.rowsPerPageOtherDetail}
                    handleChangeRowsPerPage={
                      this.handleChangeRowsPerPageOtherDetail
                    }
                    handleOnRowDataChange={
                      this.handleOnRowDataChangeOtherDetail
                    }
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isPaymodePaid === true ? (
          <>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <PaymentModeTable
                  DefaultEntrySettingList={DefaultEntrySettingList}
                  PaymentData={this.state.PaymentData}
                  PaymentLedgerNameList={this.state.rowsPaymentMode}
                  Edit_SrNo={this.state.formData.edit_purchasesrno}
                  setPaymentData={this.setPaymentData}
                  txtAmount={txtAmount4PaymentModeTable}
                />
                {/* <TableList
                  columns={this.state.columnsPaymentMode}
                  counter={this.state.counter}
                  rows={this.state.rowsPaymentMode}
                  rowsCount={this.state.rowsCountPaymentMode}
                  rowsPerPage={this.state.rowsPerPagePaymentMode}
                  handleChangeRowsPerPage={
                    this.handleChangeRowsPerPagePaymentMode
                  }
                  handleOnRowDataChange={this.handleOnRowDataChangePaymentMode}
                /> */}
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item display={isDisplaySaveBtn}>
                  <CtBtn
                    label="Save"
                    onClick={() => {
                      this.trimFormData(() => {
                        this.savePurchase();
                      });
                    }}
                  />
                </Grid>
                <Grid item>
                  <CtBtn label="New" onClick={this.clearInfo} />
                </Grid>
                <Grid
                  item
                  display={
                    this.props.userPrivilege.Purchase !== "M" ? "none" : "block"
                  }
                >
                  <CtBtn label="Delete" onClick={this.onDeleteBtnClick} />
                </Grid>
                {/* <Grid item>
                <CtBtn label="Payment Mode" onClick={this.onPaymentModeClick} />
                </Grid> */}
                <Grid item>
                  <CtBtn
                    label="Purchase List"
                    onClick={() => {
                      this.props.navigateTo("PurchaseList");
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          ""
        )}
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          // provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Purchase Item Entry"
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(PurchaseEntry))));
